import { Component, Mixins, VModel, Prop } from 'vue-property-decorator'
import MixinInterface from '@/_mixins/index'

import TagModel from '@/views/Language/models/tag'
@Component({
    inheritAttrs: false,
    components: {},
})
export default class Tags extends Mixins<MixinInterface>() {
    @VModel() tags!: Array<string>
    @Prop({ default: false }) allowDisabled!: boolean

    get allTags(): Array<TagModel> {
        return this.$store.getters.tags
    }

    search = ''
    editing: null | TagModel = null
    editingIndex = -1

    get isSearchValid() {
        return this.validTagName(this.search)
    }

    validTagName(name: string) {
        let res = name && name.length > 1 && /^[A-Za-z0-9-_\.]+$/.test(name)
        if (res) {
            this.allTags.map((obj: TagModel) => {
                if (obj.name.toLowerCase() == name.toLowerCase()) {
                    res = false
                }
            })
        }
        return res
    }

    loadingEdit: string | false = false
    async edit(item) {
        if (!this.editing) {
            this.editing = JSON.parse(JSON.stringify(item))
            this.editingIndex = this.allTags.findIndex((tag) => tag._id == item._id)
        } else {
            if (this.editingIndex && this.editing.name == this.allTags[this.editingIndex].name) {
                this.editing = null
                this.editingIndex = -1
                this.loadingEdit = false
            } else if (!this.loadingEdit && this.validTagName(this.editing.name)) {
                this.loadingEdit = item._id
                await item.patchName(this.editing.name)
                this.editing = null
                this.editingIndex = -1
                this.loadingEdit = false
            }
        }
    }

    loadingDelete: string | false = false
    async deleteTag(item: TagModel) {
        if (this.isSuperuser && !this.loadingDelete && item._id) {
            this.loadingDelete = item._id
            await item.delete()
            this.loadingDelete = false
        }
    }

    loadingAdd = false
    async add() {
        if (this.isSuperuser && this.isSearchValid && !this.loadingAdd) {
            this.loadingAdd = true
            let data = {
                type: 'tag',
                attributes: {
                    name: this.search,
                },
            }

            let tag = await TagModel.post(data)

            if (tag) {
                this.$emit('tagCreated', tag)
                this.search = ''
            }
            this.loadingAdd = false
        }
    }
}
